<template>
  <div class="logo">
    <router-link :to="{ name: 'index' }" style="display: block">
      <img src="~@/assets/logo.png" />
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  components: {},
  props: {
    title: {
      type: String,
      default: '图片标注平台',
      required: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
};
</script>
